import type { ReactNode } from 'react'

import { cn } from '@/lib/utils/cn'

import styles from './InfoBanner.module.css'

interface InfoBannerProps {
  children: ReactNode
  icon?: ReactNode
  className?: string
}

/** A quiet note inside a form — how something works, not that it went wrong. */
export function InfoBanner({ children, icon, className }: InfoBannerProps) {
  return (
    <p className={cn(styles.banner, className)}>
      {icon}
      {children}
    </p>
  )
}
